// src/helpers/orderingFacilityToast.js
import userConstants from "@/config/constants/userConstants";
import { alertBox} from "@/helpers/notifications";

export async function checkRequiresAttentionToast({
  userDetails,
  state,
  commit,
  dispatch,
  rootGetters,
}) {
  const orderingFacility = userConstants.GROUPED_USER_TYPES.find(
    (group) => group.label === "Ordering Facility"
  );

  const isOrderingFacility = orderingFacility?.options.some(
    (option) => option.value === userDetails.user_type
  );

  if (isOrderingFacility && !state.hasShownAttentionToast) {
    try {
      await dispatch(
        "orders/getOrders",
        { statuses: ["ACTIVE", "PARTIAL"], issues: true, page: 1, limit: 1 },
        { root: true }
      );

      await new Promise((resolve) => setTimeout(resolve, 100));

      const orders = rootGetters["orders/getAllOrders"];
      const orderList = Array.isArray(orders) ? orders : orders?.data || [];

      if (orderList.length > 0) {
       alertBox(
          "You have orders flagged with issues. Please review them under 'Requires Attention'.",
          "Requires Attention"
        );
        commit("auth/setHasShownAttentionToast", true, { root: true });
      }
    } catch (error) {
      console.error("Failed to fetch requires-attention orders:", error);
    }
  }
}
